import { render } from "./ObservationModal.vue?vue&type=template&id=420d85fc&scoped=true"
import script from "./ObservationModal.vue?vue&type=script&lang=js"
export * from "./ObservationModal.vue?vue&type=script&lang=js"

import "./ObservationModal.vue?vue&type=style&index=0&id=420d85fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420d85fc"]])

export default __exports__